import * as React from "react";
import { useState } from "react";
function LazyImage(_a) {
  var url = _a.url,
    className = _a.className,
    placeHolder = _a.placeHolder;
  var _b = useState(false),
    loaded = _b[0],
    setLoaded = _b[1];
  if (placeHolder && !loaded) {
    return /*#__PURE__*/React.createElement("img", {
      src: '/img/transparent.png',
      alt: '',
      className: className
    });
  } else {
    if (!loaded) {
      setLoaded(true);
    }
    return /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: '',
      className: className
    });
  }
}
export default LazyImage;